// extracted by mini-css-extract-plugin
export default {"feedTypeLabel":"FeedDetailsFields_feedTypeLabel__dBfjH","feedTypeContainer":"FeedDetailsFields_feedTypeContainer__whRmv"};